import React from "react";

export const CustomLeftArrow = ({ onClick }: { onClick: () => void }) => (
    <button type="button" className="r-clients__arrow r-clients__arrow--left" onClick={() => onClick()}>
        <i className="icon-uEACD-angle-left" />
    </button>
);

export const CustomRightArrow = ({ onClick }: { onClick: () => void }) => (
    <button type="button" className="r-clients__arrow r-clients__arrow--right" onClick={() => onClick()}>
        <i className="icon-uEAD5-angle-right" />
    </button>
);

export const CustomButtonGroup = ({ next, previous }: any) => (
    <div className="r-relay__buttons">
        <CustomLeftArrow onClick={() => previous()} />
        <CustomRightArrow onClick={() => next()} />
    </div>
);

export const NullArrow = () => null;
